// Single source of truth for "is there a usable auth token in localStorage".
//
// `localStorage.getItem("authToken")` returning a truthy value is NOT enough:
// a logged-out / brand-new session can leave a placeholder string behind
// (`""`, or the literal `"undefined"` / `"null"` written by an errant
// setItem(key, someUndefinedVar)). Those are truthy-but-useless and, if used
// to gate a bootstrap call like getUser() (POST /auth/user-info), fire an
// unauthenticated request that 401s and surfaces a "Request failed with
// status code 401" toast on the login page.
//
// Use this everywhere a token gates a network bootstrap so the check means
// "we actually have a token", not merely "the key exists".
export function getStoredAuthToken() {
  if (typeof window === "undefined") return null;
  let raw = null;
  try {
    raw = localStorage.getItem("authToken");
  } catch (_e) {
    // private mode / storage disabled
    return null;
  }
  if (typeof raw !== "string") return null;
  const token = raw.trim();
  if (!token || token === "undefined" || token === "null") return null;
  return token;
}

export function hasStoredAuthToken() {
  return getStoredAuthToken() != null;
}
